import type { TableFootProps } from './table.types';
import { TableSection } from './tableSection/tableSection';

export const TableFoot = ({ children, fixed = true }: TableFootProps) => (
  <TableSection element="tfoot" fixed={fixed}>
    {children}
  </TableSection>
);
